function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "DE");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFFFFF",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F0F0F0",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "linearGradient-2"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#262626",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0D0D0D",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "linearGradient-3"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F01515",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DE0000",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "linearGradient-4"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD521",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFCF00",
  offset: "100%"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "DE"
}, /*#__PURE__*/React.createElement("rect", {
  id: "FlagBackground",
  fill: "url(#linearGradient-1)",
  x: 0,
  y: 0,
  width: 21,
  height: 15
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2",
  fill: "url(#linearGradient-2)",
  x: 0,
  y: 0,
  width: 21,
  height: 5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2",
  fill: "url(#linearGradient-3)",
  x: 0,
  y: 5,
  width: 21,
  height: 5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2",
  fill: "url(#linearGradient-4)",
  x: 0,
  y: 10,
  width: 21,
  height: 5
})));

var SvgDe = function SvgDe(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "15px",
    viewBox: "0 0 21 15",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDe, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/de.1a0abb45.svg";
export { ForwardRef as ReactComponent };